import React from "react";
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import moment from 'moment';
import {getInventorytransactions, getInventorytransaction, registerInventorytransaction, updateInventorytransaction, deleteInventorytransaction } from './../../actions/inventorytransaction';
import { getInventorycategorys } from './../../actions/inventorycategory';
import { getInventorytypes } from './../../actions/inventorytype';
import $ from "jquery";
import { alllocations,  } from "./../../actions/common";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import FormInventoryTransaction from "views/Form/FormInventoryTransaction";

const locs = alllocations;
let inventors = {
    1:'Supply',
    2:'Dispatched',
    3:'Deployed',
    4:'Damaged',
}
class BottomCard extends React.Component {
   constructor(props){
       super(props);
       this.state ={
           id:null,
           cat:null,
            grp:null,
            afid:false,
            tfid:false,
            cfid:false,
            mfid:false,
            ifid:false,
            mid:null,
            fid:false,
            data:{},
            subtopic:'All Categories',
            started:'',
            ended:'',
            daterange:'',
            isshown:{}

       }
   }

    componentDidMount(){
        let re = {
            data:JSON.stringify({}),
            cat:'inventoryall',
            table:'inventory_types'
        };
        this.props.getInventorytypes(re);
       
        //GET PROPS
        let id = this.props.id;
        let cat = this.props.cat && parseInt(this.props.cat) > 0 ? parseInt(this.props.cat) : 2;
        let dt = new Date();
	    let started  = new Date(dt.getFullYear(), dt.getMonth(), 1);
        let ended = new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
        let daterange = ' '+moment(started).format('MMMM Do YYYY') + ' - ' + moment(ended).format('MMMM Do YYYY');
        
	    this.setState({
             id:id,
             cat:cat,
	         started: moment(started).format("YYYY-MM-DD"),
             ended: moment(ended).format("YYYY-MM-DD"),
             daterange:daterange
	    })
            
        
        //GET ALL CATEGORYS
        let res = {};
        let ctn = '';
        let params = {};
        if(parseInt(id) > 0)
        {
            if(parseInt(cat) === 1)
            {
                res = {
                    'starts':moment(new Date(started)).format('YYYY-MM-DD'),
                    'ends':moment(new Date(ended)).format('YYYY-MM-DD'),
                    'locationid':this.props.user.location,
                    'categoryid':id
                };
                let catname = this.props.inventorytypes.inventorytypes && Array.isArray(this.props.inventorytypes.inventorytypes) && this.props.inventorytypes.inventorytypes.length > 0 ? this.props.inventorycategorys.inventorycategorys.filter(rw=>parseInt(rw.id) === parseInt(id))[0] : {'name':''}
                ctn = catname !== undefined ? catname.name :'None';
                 params = {
                    data:JSON.stringify(res),
                    cat:'inventorytransaction',
                    table:'inventory_transactions'
                 }
            }
            else if(parseInt(cat) === 2){
                let aatname = this.props.inventorytypes.inventorytypes && Array.isArray(this.props.inventorytypes.inventorytypes) && this.props.inventorytypes.inventorytypes.length > 0 ? this.props.inventorytypes.inventorytypes.filter(rw=>parseInt(rw.id) === parseInt(id))[0] : {'name':''}
                let atnid = aatname !== undefined ? aatname.categoryid :null;
                let atnm = aatname !== undefined ? aatname.name :null;
                let catname = atnid !== null && parseInt(atnid) > 0 && this.props.inventorycategorys.inventorycategorys && Array.isArray(this.props.inventorycategorys.inventorycategorys) && this.props.inventorycategorys.inventorycategorys.length > 0 ? this.props.inventorycategorys.inventorycategorys.filter(rw=>parseInt(rw.id) === parseInt(atnid))[0] : {'name':''} 
                let ctnid = catname !== undefined ? catname.name :null;
                ctn = ctnid +' '+atnm;
                res = {
                    'starts':moment(new Date(started)).format('YYYY-MM-DD'),
                    'ends':moment(new Date(ended)).format('YYYY-MM-DD'),
                    'locationid':this.props.user.location,
                    'inventoryid':id
                };
                
                params = {
                    data:JSON.stringify(res),
                    cat:'inventorytransaction',
                    table:'inventory_transactions'
                    }
            }
        }else if(id = 'all'){
            res = {
                    'starts':moment(new Date(started)).format('YYYY-MM-DD'),
                    'ends':moment(new Date(ended)).format('YYYY-MM-DD'),
                    'locationid':this.props.user.location
                };
            ctn = 'Inventory Transaction List';
            params = {
                data:JSON.stringify(res),
                cat:'inventorytransaction',
                table:'inventory_transactions'
            }
        }
        this.setState({subtopic:ctn});
        this.props.getInventorytransactions(params);
        $('#myTablex').DataTable().destroy();
        $('#myTablex').DataTable();
    }
    componentDidUpdate(prevProps, prevState){
        //GET PROPS
        if(prevProps.id !== this.props.id || prevProps.user.location !== this.props.user.location || prevState.starts !== this.state.starts || prevState.ends !== this.state.ends)
        {
         //GET PROPS
         let id = this.props.id;
         let cat = this.props.cat && parseInt(this.props.cat) > 0 ? parseInt(this.props.cat) : 2;
         let started  = new Date(this.state.started);
         let ended = new Date(this.state.ended);
         let daterange = ' '+moment(started).format('MMMM Do YYYY') + ' - ' + moment(ended).format('MMMM Do YYYY');
         
         this.setState({
              id:id,
              cat:cat,
              started: moment(started).format("YYYY-MM-DD"),
              ended: moment(ended).format("YYYY-MM-DD"),
              daterange:daterange
         })
             
         
         //GET ALL CATEGORYS
         let res = {};
         let ctn = '';
         let params = {};
         if(parseInt(id) > 0)
         {
             if(parseInt(cat) === 1)
             {
             res = {
                     'starts':moment(new Date(started)).format('YYYY-MM-DD'),
                     'ends':moment(new Date(ended)).format('YYYY-MM-DD'),
                     'locationid':this.props.user.location,
                     'inventoryid':id
                 };
             let catname = this.props.inventorytypes.inventorytypes && Array.isArray(this.props.inventorytypes.inventorytypes) && this.props.inventorytypes.inventorytypes.length > 0 ? this.props.inventorycategorys.inventorycategorys.filter(rw=>parseInt(rw.id) === parseInt(id))[0] : {'name':''}
             ctn = catname !== undefined ? catname.name :'None';
                  params = {
                     data:JSON.stringify(res),
                     cat:'inventorytransaction',
                     table:'inventory_transactions'
                  }
             }
             else{
                 let aatname = this.props.inventorytypes.inventorytypes && Array.isArray(this.props.inventorytypes.inventorytypes) && this.props.inventorytypes.inventorytypes.length > 0 ? this.props.inventorycategorys.inventorycategorys.filter(rw=>parseInt(rw.id) === parseInt(id))[0] : {'name':''}
                 let atnid = aatname !== undefined ? aatname.categoryid :null;
                 let atnm = aatname !== undefined ? aatname.name :null;
                 let catname = atnid !== null && parseInt(atnid) > 0 && this.props.inventorycategorys.inventorycategorys && Array.isArray(this.props.inventorycategorys.inventorycategorys) && this.props.inventorycategorys.inventorycategorys.length > 0 ? this.props.inventorycategorys.inventorycategorys.filter(rw=>parseInt(rw.id) === parseInt(id))[0] : {'name':''} 
                 let ctnid = catname !== undefined ? catname.name :null;
                 ctn = ctnid +' '+atnm;
                 res = {
                     'starts':moment(new Date(started)).format('YYYY-MM-DD'),
                     'ends':moment(new Date(ended)).format('YYYY-MM-DD'),
                     'locationid':this.props.user.location,
                     'inventoryid':id
                 };
                 
                 params = {
                     data:JSON.stringify(res),
                     cat:'inventorytransaction',
                     table:'inventory_transactions'
                     }
             }
         }else if(id = 'all')
         {
             res = {
                     'starts':moment(new Date(started)).format('YYYY-MM-DD'),
                     'ends':moment(new Date(ended)).format('YYYY-MM-DD'),
                     'locationid':this.props.user.location
                 };
             ctn = 'Inventory Transaction List';
             params = {
                 data:JSON.stringify(res),
                 cat:'inventorytransaction',
                 table:'inventory_transactions'
             }
         }
         this.setState({subtopic:ctn});
         this.props.getInventorytransactions(params);
         $('#myTablex').DataTable();
         
        }
            

    }
    componentWillUnmount(){
        $('#myTablex').DataTable().destroy();
    }
    control = (id, func, uss) =>{
        Swal.fire({
            title: 'Confirm/Approve Entry',
            type: 'question',
            html: '<select id="txts1"  class="swal2-input form-control"><option value="1">Approved</option><option value="2">Unapproved</option></select>',
            customClass: 'swal2-overflow',
            
          }).then(function(result) {
                  let num = $('#txts1').val();
                  let fd = new FormData();
                  fd.append('id', id);
                  fd.append('is_approved', num);
                  fd.append('admin', uss.user.surname +" "+uss.user.firstname);
                  fd.append('admin_dated', moment(new Date()).format("YYYY-MM-DD hh:mm:ss"));
                  fd.append('table', 'inventory_transactions');
                  fd.append('cat', 'update');
                  fd.append('rowzid', uss.user.id);
                  fd.append('locateid', num =1 ? 'Approved':'Unapproved' + ' leave');
                  func(fd);
              
          });    
    }
    retState = (dt, dt1) =>{
        let daterange = ' '+moment(dt).format('MMMM Do YYYY') + ' - ' + moment(dt1).format('MMMM Do YYYY');
        this.setState({started:new Date(dt), ended:new Date(dt1), daterange:daterange});
    }
    //EDIT INVENTORY
    editForm = (id, dat) =>{
        this.props.getInventorytransaction(id);
        this.setState({cfid:true, mid:id});
    }
    //DELETE INVENTORY
    deleteForm = id =>{
        Swal.fire({
            title: 'Are you sure?',
            text: "You will not be able restore",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
        
            if (result.value) {
                let fd = new FormData();
                fd.append('id', id);
                fd.append('is_delete', 1);
                fd.append('cat', 'update');
                fd.append('table', 'inventory_transactions');
                this.props.updateInventorytransaction(fd);
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })
        
    }
    //ACTIVATE INVENTORY
    activateForm = (id, ac) =>{
        let act = ac === 0 ? 1 : 0;
        let fd = new FormData();
        fd.append('id', id);
        fd.append('is_active', act);
        fd.append('cat', 'update');
        fd.append('table', 'inventory_transactions');
        this.props.updateInventorytransaction(fd);
    }
   
    loadShown = (id, cat) =>{
          let ar = {};
          if(cat === 0)
          {
              ar[id] = true;
          }else{
              ar[id] = false;
          }
          this.setState({isshown:ar});
    }
    lunchDate = (func, func1, locs) =>{
        Swal.fire({
            title: 'Pick a date from and to:',
            type: 'question',
            html: '<input id="datepicker" type="date"  class="swal2-input"><br/><input id="datepicker1" type="date"  class="swal2-input">',
            customClass: 'swal2-overflow',
            
          }).then(function(result) {
              if(result.value)
              {
                  let v = $('#datepicker').val();
                  let v1 = $('#datepicker1').val();
                  let params = {
                    data:JSON.stringify(
                    {
                        'starts':moment(new Date(v)).format('YYYY-MM-DD'), 
                        'ends':moment(new Date(v1)).format('YYYY-MM-DD'), 
                        'locationid':locs
                    }),
                    cat:'inventorytransaction',
                    table:'inventory_transaction'
                }
                func(params);
                func1(v, v1);
              }
          });
    }

    render() {
        let { cfid, mid, isshown, subtopic, daterange } = this.state  || '';
        let data = this.props.inventorytransactions.inventorytransactions;
        
        let tabl = data && Array.isArray(data) ? data.filter(rw=>rw !== null).map((prop, ind)=>{
            return <tr 
                    key={ind}
                        style={{padding:'1px', margin:'0px'}}
                        onMouseEnter={()=>this.loadShown(prop.id, 0)}
                        onMouseLeave={()=>this.loadShown(prop.id, 1)}
                        >
                        <td className='text-center'>{String(prop.id).padStart(7, '0')}</td>
                        <td>
                            <small><b>{moment(prop.transaction_date).format('DD-MM-YYYY')}</b></small><br/>
                            <small><b>{prop.admin_dated ? moment(prop.admin_dated).format('DD-MM-YYYY'): 'Not Confirmed'}</b></small>
                        </td>
                        <td style={{textAlign:'left'}}>
                            {prop.inventoryname}
                            { prop.id in isshown && isshown[prop.id] === true ? 
                                <span className='reportcontrol pull-right'>
                                    <a  onClick={()=>this.control(prop.id, this.props.updateInventorytransaction, this.props.user)} title='Block/Unblock Issue' href='#'>{<i className= {parseInt(prop.is_active) === 0 ? "fa fa-thumbs-up" : "fa fa-thumbs-down"}></i>}</a>
                                    <a onClick={()=>this.editForm(prop.id, prop)} title='Edit' href='#'><i className='fa fa-edit'></i></a>
                                    <a onClick={()=>this.deleteForm(prop.id, prop)} title='Delete' href='#'><i className='now-ui-icons ui-1_simple-remove'></i></a>
                                </span>
                            : ''}
                        </td>
                        <td>
                            {inventors[parseInt(prop.status)]}
                        </td>
                        <td>{prop.quantity}</td>
                        <td>{prop.receiver}</td>
                        <td style={{textAlign:'left'}}>
                            <b><small>REC:<i>{prop.username}</i></small><br/><small className={parseInt(prop.is_approved) === 1 ? 'inventoryapp': parseInt(prop.is_approved) === 2 ? 'inventoryuapp' : '' }>APP:<i>{prop.admin}</i></small></b>
                            </td>
                    </tr>
                }): '';
        


        return (
            <>
            
            {cfid === true ? 
            <FormInventoryTransaction
                st={cfid}
                mid={mid}
                handleClose={()=>this.setState({mid:null, cfid:false})}
            />:''}
           
              <div className="content">
                  <div className='card'>
                  <div className='card-header tablecardheader'>
                  
                  <Container xs='12'>
                          <Row xs='12'>
                              <Col md='6' sm='12'>
                              <h4 className='cardtitl'>{subtopic}</h4>
                              <span>{daterange}</span>
                              </Col >
                              <Col md='6' sm='12' className='pull-right'>
                              <a href='#' className='btn btn-outline-info btn-sm' onClick={()=>this.editForm(null, {})}><i className='now-ui-icons ui-1_simple-add'></i> Inventory Record Form</a>
                              <Link to={`/account/inventorys/${this.state.id}`}><button className='btn btn-outline-primary btn-sm'><i className='fa fa-backward'></i> Back</button></Link>
                              <a class="btn btn-outline-info btn-sm" onClick={()=>this.lunchDate(this.props.getInventorytransactions, this.retState, this.props.user.location)} href="#">
                                <i className="now-ui-icons ui-1_calendar-60"></i></a>
                              </Col >

                          </Row>
                      </Container>
                  </div>
                  <div className='card-body table-responsive'>
                    <table ref={el=>this.el = el} className='table-bordered display wrap table-striped mytables table-condensed table-hover'  id='myTablexz' width='100%' >
                        <thead>
                            <tr>
                                <th style={{maxWidth:'50px'}}>TID</th>
                                <th><small>Recorded Date: <br/>Confirmation Date:</small> </th>
                                <th>Item</th>
                                <th>Status</th>
                                <th>QTY</th>
                                <th><small>Received By: <br/>Supplied By:</small></th>
                                <th><small>Recorded By: <br/>Approved By:</small></th>
                            </tr>
                        </thead>
                        <tbody>
                            {tabl}
                        </tbody>
                    </table>
                  </div>
                  </div>
              </div>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({ 
    user:state.userReducer,
    inventorycategorys:state.inventorycategoryReducer,
    inventorytypes:state.inventorytypeReducer,
    inventorytransactions:state.inventorytransactionReducer
  })
  
export default connect(mapStateToProps, 
    { 
        getInventorytransactions,
        getInventorytransaction,
        updateInventorytransaction,
        registerInventorytransaction,
        deleteInventorytransaction,
        getInventorycategorys,
        getInventorytypes
    })(BottomCard)
